import type { BadgeTone } from '@/components/ui/badge';

const STATUS_TONES: Record<string, BadgeTone> = {
  open: 'muted',
  assigned: 'neutral',
  in_progress: 'warning',
  waiting_on_practitioner: 'warning',
  resolved: 'success',
  closed: 'muted',
};

const PRIORITY_TONES: Record<string, BadgeTone> = {
  low: 'muted',
  normal: 'neutral',
  high: 'warning',
  urgent: 'danger',
};

export function resolveStatusTone(status: string): BadgeTone {
  const tone = STATUS_TONES[status];
  return tone === undefined ? 'neutral' : tone;
}

export function resolvePriorityTone(priority: string): BadgeTone {
  const tone = PRIORITY_TONES[priority];
  return tone === undefined ? 'neutral' : tone;
}

export function buildStatusTranslationKey(status: string): string {
  return 'support:status.' + status;
}

export function buildCategoryTranslationKey(category: string): string {
  return 'support:category.' + category;
}

export function buildPriorityTranslationKey(priority: string): string {
  return 'support:priority.' + priority;
}

export function buildEventTranslationKey(eventType: string): string {
  return 'support:event.' + eventType;
}

export function buildMediaKindTranslationKey(mediaKind: string): string {
  if (mediaKind === 'image') {
    return 'support:media.image';
  }
  if (mediaKind === 'video') {
    return 'support:media.video';
  }
  return 'support:media.document';
}
